import React from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
} from "recharts";

interface LineChartProps {
  data: {
    name: string;
    value: any;
  }[];
  width?: number;
}

export default ({ data = [], width = 600 }: LineChartProps) => {
  return (
    <LineChart
      width={width}
      height={width / 2}
      data={data}
      margin={{ top: 5, right: 30, left: -30, bottom: 5 }}
    >
      <XAxis dataKey="name" />
      <YAxis />
      <CartesianGrid strokeDasharray="3 3" />
      <Tooltip />
      <Line type="monotone" dataKey="value" stroke="#82ca9d" />
    </LineChart>
  );
};
